(function () {
  'use strict';

  var STORAGE_KEY = 'rbt_j2_item_list_map';
  var GA4_DEFAULT = 'G-63ZELX03L4';
  var ENRICH_EVENTS = ['view_item', 'add_to_cart', 'begin_checkout', 'purchase', 'select_item'];

  function readMap() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function writeMap(map) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch (error) {}
  }

  function stashListContext(variantId, sku, ctx) {
    if (!variantId && !sku) return;
    var map = readMap();
    if (variantId) map[String(variantId)] = ctx;
    if (sku) map[String(sku)] = ctx;
    writeMap(map);
  }

  function lookupContext(item) {
    if (!item) return null;
    var map = readMap();
    var keys = [
      item.item_id,
      item.id,
      item.item_variant_id,
      item.variant_id,
      item.sku,
      item.item_sku,
    ];
    for (var i = 0; i < keys.length; i++) {
      if (keys[i] != null && keys[i] !== '' && map[String(keys[i])]) {
        return map[String(keys[i])];
      }
    }
    return null;
  }

  function enrichItems(items) {
    if (!items || !items.length) return items;
    var changed = false;
    var next = items.map(function (item) {
      if (!item || typeof item !== 'object') return item;
      if (item.item_list_name) return item;
      var ctx = lookupContext(item);
      if (!ctx) return item;
      changed = true;
      return Object.assign({}, item, {
        item_list_id: item.item_list_id || ctx.item_list_id,
        item_list_name: item.item_list_name || ctx.item_list_name,
        index: item.index || ctx.index,
      });
    });
    return changed ? next : items;
  }

  function enrichEventPayload(payload) {
    if (!payload || typeof payload !== 'object') return payload;

    if (Array.isArray(payload.items) && payload.items.length) {
      payload.items = enrichItems(payload.items);
    }

    if (payload.ecommerce && Array.isArray(payload.ecommerce.items)) {
      payload.ecommerce.items = enrichItems(payload.ecommerce.items);
    }

    return payload;
  }

  function shouldEnrichEventName(name) {
    if (!name) return false;
    return ENRICH_EVENTS.indexOf(String(name)) !== -1;
  }

  function patchDataLayer() {
    if (!window.dataLayer || window.dataLayer.__rbtJ2Patched) return;
    var originalPush = window.dataLayer.push;
    window.dataLayer.push = function () {
      var args = Array.prototype.slice.call(arguments);
      args.forEach(function (entry) {
        if (!entry || typeof entry !== 'object') return;
        var eventName = entry.event || entry.en || '';
        if (!shouldEnrichEventName(eventName)) return;
        enrichEventPayload(entry);
      });
      return originalPush.apply(window.dataLayer, args);
    };
    window.dataLayer.__rbtJ2Patched = true;
  }

  function patchGtag() {
    if (window.__rbtJ2GtagPatched || typeof window.gtag !== 'function') return;
    var originalGtag = window.gtag;
    window.gtag = function () {
      var args = Array.prototype.slice.call(arguments);
      if (args[0] === 'event' && args[1] && shouldEnrichEventName(args[1]) && args[2]) {
        args[2] = enrichEventPayload(Object.assign({}, args[2]));
      }
      return originalGtag.apply(window, args);
    };
    window.__rbtJ2GtagPatched = true;
  }

  function sendGa4Event(eventName, params) {
    var payload = enrichEventPayload(Object.assign({}, params || {}));
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
  }

  function getListConfig(root) {
    var configEl = document.querySelector('[data-j2-collection-list-config]');
    if (configEl) {
      try {
        return JSON.parse(configEl.textContent);
      } catch (error) {}
    }

    if (root) {
      var listId = root.getAttribute('data-j2-list-id');
      var listName = root.getAttribute('data-j2-list-name');
      if (listId && listName) {
        return { listId: listId, listName: listName };
      }
    }

    return null;
  }

  function getCardVariantId(card) {
    return (
      card.getAttribute('data-j2-variant-id') ||
      card.querySelector('[data-current-variant-id]')?.getAttribute('data-current-variant-id') ||
      card.getAttribute('data-initial-variant-id') ||
      ''
    );
  }

  function cardToItem(card, index, listId, listName) {
    var variantId = getCardVariantId(card);
    if (!variantId) return null;

    var priceCents = parseInt(card.getAttribute('data-j2-item-price'), 10) || 0;
    var itemName = card.getAttribute('data-j2-item-name') || '';
    var sku = card.getAttribute('data-j2-item-sku') || '';

    return {
      item_id: String(variantId),
      item_name: itemName,
      item_list_id: listId,
      item_list_name: listName,
      index: index + 1,
      price: priceCents / 100,
      sku: sku,
    };
  }

  function collectGridItems(root, listId, listName) {
    var cards = root.querySelectorAll('[data-j2-collection-item]');
    var items = [];
    cards.forEach(function (card, index) {
      var item = cardToItem(card, index, listId, listName);
      if (item) items.push(item);
    });
    return items;
  }

  function fireViewItemList(root) {
    var config = getListConfig(root);
    if (!config || !config.listId || !config.listName) return;

    var grid =
      root.querySelector('[data-collection-results]') ||
      root.querySelector('.rabitat-collection-page__grid') ||
      root;

    var items = collectGridItems(grid, config.listId, config.listName);
    if (!items.length) return;

    sendGa4Event('view_item_list', {
      item_list_id: config.listId,
      item_list_name: config.listName,
      items: items.map(function (item) {
        return {
          item_id: item.item_id,
          item_name: item.item_name,
          item_list_id: item.item_list_id,
          item_list_name: item.item_list_name,
          index: item.index,
          price: item.price,
        };
      }),
    });

    if (window.console && console.info) {
      console.info('[J2] view_item_list', config.listName, items.length, 'items');
    }
  }

  function fireSelectItem(card, index, listId, listName) {
    var item = cardToItem(card, index, listId, listName);
    if (!item) return;

    stashListContext(item.item_id, item.sku, {
      item_list_id: listId,
      item_list_name: listName,
      index: item.index,
    });

    sendGa4Event('select_item', {
      item_list_id: listId,
      item_list_name: listName,
      items: [
        {
          item_id: item.item_id,
          item_name: item.item_name,
          item_list_id: listId,
          item_list_name: listName,
          index: item.index,
          price: item.price,
        },
      ],
    });

    if (window.console && console.info) {
      console.info('[J2] select_item', listName, item.item_name);
    }
  }

  function cardIndexInGrid(card, grid) {
    var cards = grid.querySelectorAll('[data-j2-collection-item]');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i] === card) return i;
    }
    return 0;
  }

  function isProductCardNavigation(target) {
    if (!target || !target.closest) return false;
    var link = target.closest('a[href*="/products/"]');
    if (!link) return false;
    if (link.closest('[data-spares-card-add], [data-product-card-quick-add], [data-spares-card-personalise]')) {
      return false;
    }
    return true;
  }

  function bindCollectionSection(sectionWrap) {
    if (!sectionWrap || sectionWrap.dataset.j2CollectionBound === 'true') return;
    sectionWrap.dataset.j2CollectionBound = 'true';

    fireViewItemList(sectionWrap);

    sectionWrap.addEventListener('click', function (event) {
      if (!isProductCardNavigation(event.target)) return;

      var card = event.target.closest('[data-j2-collection-item]');
      if (!card || !sectionWrap.contains(card)) return;

      var config = getListConfig(sectionWrap);
      if (!config) return;

      var grid =
        sectionWrap.querySelector('[data-collection-results]') ||
        sectionWrap.querySelector('.rabitat-collection-page__grid') ||
        sectionWrap;

      fireSelectItem(card, cardIndexInGrid(card, grid), config.listId, config.listName);
    });
  }

  function initCollectionPages() {
    document.querySelectorAll('[data-collection-section]').forEach(bindCollectionSection);
  }

  patchDataLayer();
  patchGtag();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchGtag();
      initCollectionPages();
    });
  } else {
    patchGtag();
    initCollectionPages();
  }

  document.addEventListener('rabitat:collection:updated', function (event) {
    patchGtag();
    var root = event.detail && event.detail.root;
    if (!root) return;
    root.dataset.j2CollectionBound = 'false';
    bindCollectionSection(root);
  });

  window.rbtJ2CollectionList = {
    readMap: readMap,
    stashListContext: stashListContext,
    fireViewItemList: fireViewItemList,
  };
})();
